<template>
  <div class="banner-management">
    <template v-if="view === 1">
      <div class="main-title">
        <p>
          <span class="bold-text">banner管理</span>
        </p>
      </div>
      <div class="main-body">
        <div class="filter-bar">
          <div class="item" style="width: 100%; text-align: right">
            <el-button type="primary" style="width: 100px" @click="showForm(1)">新增</el-button>
          </div>
        </div>

        <table class="table-custom" style="margin-top: 20px">
          <thead>
          <tr>
            <th>序号</th>
            <th>内容</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody v-if="dataList.length>0">
          <tr v-for="(item, index) in dataList" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <el-image style="width: 100px" fit="fill" :src="item.imageUrl" alt=""></el-image>
            </td>
            <td>{{ parseTime(item.createTime) }}</td>
            <td>
              <el-button type="primary" size="mini" @click="showForm(2, item)">编辑</el-button>
              <el-button type="primary" size="mini" @click="onDelete(item.number)">删除</el-button>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="4" style="text-align: center">暂无数据</td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>
    <banner-form v-else :type="formType" :data="formData" @back="back"></banner-form>
  </div>
</template>

<script>
import bannerForm from "./bannerForm";
import {parseTime} from "../../utils";

export default {
  name: "bannerManagement",
  components: {bannerForm},
  data() {
    const currentTime = new Date().getTime();
    return {
      dataList: [],
      beginIndex: 0,
      pageSize: 10,
      reachEnd: true,
      formType: 1,
      formData: {},
      view: 1, // 1 列表  2 表单,
      parseTime
    }
  },

  mounted() {
    this.getDataList();
  },

  methods: {

    onDelete(number) {
      this.$confirm("确定要删除吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http.post('/managementPlatform/admin/deleteBanner', this.$qs.stringify({number})
        ).then(response => {
          let res = response.data;
          if (!res || !res.result) {
            return this.$message.error(res.message)
          }
          this.$message.success("操作成功");
          this.getDataList();
        }).catch(function (response) {
          console.log(response);
        });
      })
    },

    back(needRefresh) {
      this.view = 1;
      if (needRefresh) {
        this.endTime = new Date().getTime() + 1000;
        this.getDataList();
      }
    },

    getDataList() {
      this.$http.get('/managementPlatform/admin/getBannerList?').then(response => {
        let res = response.data;
        if (!res || !res.result) {
          return this.$message.error(res.message)
        }
        this.reachEnd = res.ldata.length < this.pageSize + 1;
        if (!this.reachEnd) {
          res.ldata.pop();
        }
        this.dataList = res.ldata;
      }).catch(function (response) {
        console.log(response);
      });
    },

    showForm(formType, data) {
      if (formType === 2) {
        this.formData = {...data};
      } else {
        this.formData = {}
      }
      this.formType = formType;
      this.view = 2;
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-management {
  .filter-bar {
    display: flex;
    align-items: center;

    .item {
      margin-right: 10px;
      min-width: 260px;

      .el-input {
        width: 160px;
      }

      .el-cascader,
      .el-select,
      .el-date-editor {
        width: 200px;
      }
    }
  }

  .table-custom {
    th, td {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/marketingMgmt/bannerManagement.vue